export const Thumb = ({ colors }: { colors: [string, string, string] }) => {
  return (
    <svg
      width="87"
      height="89"
      viewBox="0 0 87 89"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_f_10133_6952)">
        <ellipse
          cx="19.8185"
          cy="20.8372"
          rx="19.8185"
          ry="20.8372"
          transform="matrix(-0.999267 -0.038286 -0.038286 0.999267 64.2036 24.5156)"
          fill="url(#paint0_linear_10133_6952)"
        />
      </g>
      <circle
        cx="44.2036"
        cy="44.1602"
        r="17"
        transform="rotate(-180 44.2036 44.1602)"
        fill="white"
        stroke="url(#paint1_linear_10133_6952)"
        strokeWidth="2"
      />
      <defs>
        <filter
          id="filter0_f_10133_6952"
          x="0.706766"
          y="0.667704"
          width="85.7901"
          height="87.8208"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="11.5372"
            result="effect1_foregroundBlur_10133_6952"
          />
        </filter>
        <linearGradient
          id="paint0_linear_10133_6952"
          x1="0"
          y1="20.8372"
          x2="39.6371"
          y2="20.8372"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={colors[0]} />
          <stop offset="0.504274" stopColor={colors[1]} />
          <stop offset="1" stopColor={colors[2]} />
        </linearGradient>
        <linearGradient
          id="paint1_linear_10133_6952"
          x1="26.2036"
          y1="44.1602"
          x2="62.2036"
          y2="44.1602"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={colors[0]} />
          <stop offset="0.504274" stopColor={colors[1]} />
          <stop offset="1" stopColor={colors[2]} />
        </linearGradient>
      </defs>
    </svg>
  );
};
